module.exports = __webpack_public_path__ + "img/组29.a0090013.png";